import { Link } from "react-router-dom";
import categories from "../data/categories";
import "./CategoryGrid.css";

function CategoryGrid({ eyebrow, title, intro }) {
	const hasHeader = eyebrow || title || intro;

	return (
		<section className="category-grid-section">
			{hasHeader && (
				<div className="category-grid-header stagger-item" style={{ "--stagger-index": 0 }}>
					{eyebrow && (
						<span className="category-grid-eyebrow">{eyebrow}</span>
					)}
					{title && <h2 className="category-grid-title">{title}</h2>}
					{intro && <p className="category-grid-intro">{intro}</p>}
				</div>
			)}

			<div className="category-grid">
				{categories.map((cat, index) => (
					<Link
						key={cat.slug}
						to={cat.route}
						className="category-card stagger-item"
						style={{ "--stagger-index": index + 1 }}
						aria-label={`Bekijk ${cat.title}`}>
						<div className="category-card-imagewrap">
							<img
								src={cat.image}
								alt={cat.title}
								className="category-card-image"
								loading="lazy"
							/>
						</div>
						<div className="category-card-text">
							<h3 className="category-card-title">{cat.title}</h3>
							<p className="category-card-tease">{cat.tease}</p>
							<span className="category-card-arrow">
								Bekijk <span className="category-card-arrow-mark">→</span>
							</span>
						</div>
					</Link>
				))}
			</div>
		</section>
	);
}

export default CategoryGrid;
